import { FC } from 'react';
import { Box, Stack, styled, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

import { partnersList1 } from './Partners.mocked';

const Title = styled(Typography)(({ theme }) => ({
  fontSize: 48,
  fontWeight: '500',
  lineHeight: '60px',
  [theme.breakpoints.down('sm')]: {
    fontSize: 32,
    lineHeight: '36px',
  },
}));

// this cringe code was long before, i've just added some more cringe
export const Partners: FC = () => {
  const theme = useTheme();
  const isDownSmLayout = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack>
      <Title
        textAlign="center"
        mt={{ xs: '30px', md: '70px', lg: '105px' }}
        mb={{ xs: '30px', sm: '40px', md: '50px' }}
      >
        Trusted partners worldwide
      </Title>

      <Splide
        options={{
          gap: 85,
          pagination: false,
          omitEnd: true,
          type: 'loop',
          arrows: false,
          drag: false,
          focus: 'center',
          perPage: isDownSmLayout ? 3 : 6,
          autoScroll: {
            speed: 2.2,
          },
          autoWidth: true,
        }}
        extensions={{ AutoScroll }}
      >
        {partnersList1.map(({ img, name, height, width }) => {
          return (
            <SplideSlide key={name}>
              <Stack
                height={{ xs: 75, md: 140 }}
                maxWidth={{ xs: 205, md: 'unset' }}
                justifyContent="center"
                alignItems="center"
                mx="auto"
              >
                <Box
                  component="img"
                  src={img}
                  sx={{
                    maxHeight: height,
                    maxWidth: width,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    pointerEvents: 'none',
                  }}
                />
              </Stack>
            </SplideSlide>
          );
        })}
      </Splide>
    </Stack>
  );
};
